/** Canonical German website copy for Yawas Kebab (St. Gallen). */

export const SITE = {
  name: 'Yawas Kebab',
  email: 'info@yawas-kebab.ch',
  phoneDisplay: '077 255 65 65',
  phoneTel: '0772556565',
  /** Restaurant / Betriebsadresse (Kundenkontakt & Karte) */
  addressLines: ['Schuppisstrasse', '9016 St. Gallen', 'Schweiz'] as const,
  addressOneLine: 'Schuppisstrasse, 9016 St. Gallen, Schweiz',
  addressShort: 'Schuppisstrasse, 9016 St. Gallen',
  /** Rechtliche Angaben (Impressum / UID) */
  legal: {
    ownerName: 'Mesut Yavas',
    tradeName: 'Yavas Takeaway',
    uid: 'CHE-403.025.688',
    addressLines: ['Martinsbruggstr. 81', '9016 St. Gallen', 'Schweiz'] as const,
    addressOneLine: 'Martinsbruggstr. 81, 9016 St. Gallen, Schweiz',
    phoneDisplay: '+41 76 390 95 07',
    phoneTel: '+41763909507',
  },
};

export const HERO_COPY = {
  headline: 'Hausgemachte Smash Burger in St. Gallen',
  subheadline:
    'Täglich frisch zubereitete Burger-Patties, hochwertige Zutaten und echter Geschmack – mit Leidenschaft für Qualität und Gastfreundschaft.',
  primaryCta: 'Speisekarte entdecken',
  secondaryCta: 'Abholung – Jetzt anrufen',
};

export const ABOUT_COPY = {
  title: 'Über Uns',
  subtitle: 'Mit Leidenschaft, Qualität und echter Gastfreundschaft seit 2021.',
  badge: 'Seit 2021 in St. Gallen',
  paragraphs: [
    'Seit dem 21. Juni 2021 begrüssen wir unsere Gäste in St. Gallen mit Leidenschaft und echter Gastfreundschaft.',
    'Für uns bedeutet Gastronomie weit mehr als nur gutes Essen. Es geht darum, Menschen glücklich zu machen. Das Lächeln und die Zufriedenheit unserer Gäste sind unsere grösste Motivation und geben uns jeden Tag neue Energie.',
    'Was uns besonders macht, ist unsere Herzlichkeit, unser freundlicher Service und die Liebe zum Detail. Jede Bestellung wird mit Sorgfalt frisch zubereitet.',
    'Unsere Burger-Patties werden täglich in eigener Herstellung frisch vorbereitet. Das hochwertige Rindfleisch beziehen wir täglich frisch von unserem Metzger, damit jeder Burger unseren hohen Qualitätsansprüchen gerecht wird.',
    'Besonders beliebt bei unseren Gästen sind unsere hausgemachten Smash Burger sowie unser frisch zubereiteter Döner.',
    'Wir freuen uns darauf, Sie bald persönlich bei uns begrüssen zu dürfen.',
  ],
  highlights: [
    { icon: 'ri-restaurant-2-line', label: 'Hausgemachte Patties' },
    { icon: 'ri-leaf-line', label: 'Frische Zutaten' },
    { icon: 'ri-fire-line', label: 'Täglich frisch zubereitet' },
    { icon: 'ri-heart-line', label: 'Freundlicher Service' },
  ],
};

export const VALUES_COPY = {
  subtitle: 'Unsere Werte',
  title: 'Warum Yawas Kebab?',
  description:
    'Seit 2021 stehen Qualität, Frische und ehrliche Gastfreundschaft im Mittelpunkt unseres Restaurants.',
  cards: [
    {
      icon: 'ri-restaurant-2-line',
      title: 'Hausgemachte Qualität',
      description: 'Unsere Burger-Patties werden täglich frisch von Hand hergestellt.',
      color: 'bg-amber-50 text-amber-600',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Frische Zutaten',
      description: 'Wir verwenden täglich frisches Fleisch und sorgfältig ausgewählte Zutaten.',
      color: 'bg-green-50 text-green-600',
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Gastfreundschaft',
      description: 'Freundlicher Service und zufriedene Gäste stehen für uns an erster Stelle.',
      color: 'bg-rose-50 text-rose-600',
    },
    {
      icon: 'ri-heart-3-line',
      title: 'Leidenschaft',
      description: 'Wir lieben, was wir tun – und das schmeckt man bei jedem Besuch.',
      color: 'bg-stone-100 text-stone-600',
    },
  ],
};

export const SIGNATURE_COPY = {
  eyebrow: 'Signature',
  title: 'Unser Signature Smash Burger',
  text: 'Unsere Smash Burger werden mit täglich frisch hergestellten Rindfleisch-Patties zubereitet. Hochwertige Zutaten, perfektes Grillen und unsere hausgemachte Zubereitung sorgen für ein Geschmackserlebnis, das unsere Gäste immer wieder begeistert.',
  button: 'Jetzt probieren',
};

export const CONTACT_COPY = {
  subtitle: 'Kontakt',
  title: 'Besuchen Sie uns in St. Gallen',
  description:
    'Geniessen Sie hausgemachte Smash Burger, frisch zubereiteten Döner und viele weitere Spezialitäten in angenehmer Atmosphäre.',
  routeCta: 'Route starten',
  callCta: 'Jetzt anrufen',
  boxTitle: 'Besuchen Sie uns in St. Gallen',
  boxText:
    'Geniessen Sie hausgemachte Smash Burger, frisch zubereiteten Döner und viele weitere Spezialitäten in angenehmer Atmosphäre.',
};

export const GALLERY_COPY = {
  subtitle: 'Einblicke',
  title: 'Frisch zubereitet – mit Leidenschaft aus St. Gallen',
};

export const TESTIMONIALS_COPY = {
  subtitle: 'Gästestimmen',
  title: 'Was unsere Gäste sagen',
};

export const FOOTER_COPY = {
  description:
    'Yawas Kebab in St. Gallen – hausgemachte Smash Burger, frischer Döner und echte Gastfreundschaft seit 2021.',
  catering: 'Fragen oder Reservierung?',
};

export const SEO = {
  home: {
    title: 'Yawas Kebab | Smash Burger & Döner in St. Gallen',
    description:
      'Hausgemachte Smash Burger und frischer Döner in St. Gallen. Täglich frische Patties, hochwertige Zutaten und herzliche Gastfreundschaft bei Yawas Kebab.',
    keywords:
      'Smash Burger St. Gallen, Hausgemachter Burger St. Gallen, Burger Restaurant St. Gallen, Döner St. Gallen, Kebab St. Gallen, Restaurant St. Gallen, Yawas Kebab',
  },
  menu: {
    title: 'Speisekarte | Yawas Kebab St. Gallen – Burger, Döner & mehr',
    description:
      'Entdecken Sie die Speisekarte von Yawas Kebab: hausgemachte Smash Burger, frischer Döner, Dürüm und Spezialitäten in St. Gallen.',
    keywords:
      'Speisekarte Yawas Kebab, Smash Burger St. Gallen, Döner St. Gallen, Kebab St. Gallen, Burger Restaurant St. Gallen',
  },
};
